/** @format */

import {Fragment, useMemo} from 'react';

import {FieldErrors} from 'react-hook-form';

import {Box} from '@mui/material';

import {Trans, useTranslation} from 'react-i18next';

import {BlueText, BlueTextDots, HeadingText, RegularText} from './styles';
import {FormErrorMessage, FormState} from '../types';
import {ID_FIELDS_LEFT} from '../constants';

interface Props {
  errors: FieldErrors<FormState>;
  onClickError: (value: keyof FormState) => void;
}

const FieldsLeft = ({errors, onClickError}: Props) => {
  const {t} = useTranslation();

  const formErrorMessages: FormErrorMessage[] = useMemo(
    () => [
      {
        key: 'name',
        order: 0,
        text: t('имя'),
      },
      {
        key: 'phone',
        order: 10,
        text: t('телефон для связи'),
      },
      {
        key: 'link',
        order: 20,
        text: t('сайт компании'),
      },
      {
        key: 'inn',
        order: 30,
        text: t('ИНН'),
      },
    ],
    [t],
  );

  const errorKeys = Object.keys(errors) as (keyof FormState)[];

  if (!errorKeys.length) {
    return null;
  }

  const filteredMessages = formErrorMessages
    .filter(message => errorKeys.includes(message.key))
    .toSorted((a, b) => a.order - b.order);

  return (
    <Box data-testid={ID_FIELDS_LEFT}>
      <HeadingText>
        <Trans>Осталось заполнить</Trans>:
      </HeadingText>
      {filteredMessages.map((message, index, arr) => {
        const isSingle = arr.length === 1;
        const isFirst = index === 0;
        const isLast = index === arr.length - 1;
        return (
          <Fragment key={message.key}>
            {!isSingle && (
              <>
                {!isFirst && !isLast && <BlueText>,&nbsp;</BlueText>}
                {isLast && <RegularText>&nbsp;и&nbsp;</RegularText>}
              </>
            )}
            <BlueTextDots onClick={() => onClickError(message.key)}>{message.text}</BlueTextDots>
          </Fragment>
        );
      })}
    </Box>
  );
};

export {FieldsLeft};
